import React, { useMemo } from "react";

import { readEmbeddedBuildMeta } from "../../../lib/deployBuildMeta";

const HeaderBuildVersion: React.FC = () => {
  const meta = useMemo(() => readEmbeddedBuildMeta(), []);

  if (!meta?.version) return null;

  const title = meta.builtAt
    ? `Frontend v${meta.version} · ${meta.builtAt}`
    : `Frontend v${meta.version}`;

  return (
    <span
      className="hidden select-none text-[10px] font-medium leading-none text-white/45 sm:inline"
      title={title}
      aria-label={title}
    >
      v{meta.version}
    </span>
  );
};

export default HeaderBuildVersion;
